import type {PageInfo, StateFilter} from '../types/list-types'

export interface StateFilterCounts {
  open: number | undefined
  closed: number | undefined
}

export function getStateFilterCounts(
  pageInfo: PageInfo,
  stateItemSelected: StateFilter | undefined,
): StateFilterCounts {
  const {openCount, closedCount, totalCount} = pageInfo

  if (openCount != null && closedCount != null) {
    return {open: openCount, closed: closedCount}
  }

  return {
    open: stateItemSelected === 'open' ? totalCount : undefined,
    closed: stateItemSelected === 'closed' ? totalCount : undefined,
  }
}
